import React from 'react';
import { useSelector } from 'react-redux';
import { useConnectionCRUDActions } from '@mm/state/actions/ConnectionsCRUDActions';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { ConnectionKind } from '@mm/state/model/ConnectionModel';
import '../../IntegrationBaseComponent.scss';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { PrimaryToolTip } from '../../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { useConnectionsTableActions } from '@mm/state/modules/connectionsTableState/actions';
import { ReactComponent as AccountIcon } from '../../../../../../../../layout/BotBuilderSidebar/UserDropdown/UserDropdownIcons/UserFallback.svg';
import { GoogleAccount } from '@mm/state/interfaces/googleSheet';
import { LinkOutlined } from '@ant-design/icons';
import { useViewActions } from '@mm/state/actions/viewActions';

type Props = {
  isAccountConnected: boolean;
  spreadsheetCount: number;
  accountsCount: number;
  oauthUrl: string;
  className?: string;
  name?: string;
  accounts: GoogleAccount[];
};

export const GoogleSheetsHeader = (props: Props) => {
  const {
    isAccountConnected,
    spreadsheetCount,
    accountsCount,
    oauthUrl,
    name,
    accounts,
  } = props;

  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const { setActiveIntegration } = useConnectionsTableActions();
  const { create } = useConnectionCRUDActions();

  const { showSlideoutMenu } = useViewActions();

  const addNewConnection = async () => {
    const connection = await create(activeFbPageId, {
      name: 'Connection',
      description: '',
      kind: ConnectionKind.WIDGET,
      connectionKind: 'google_spreadsheet',
    });

    if (connection) {
      showSlideoutMenu('googleSheetIntegrationEditor', {
        widgetId: connection.id,
      });
    }
  };

  const onClickAddNew = () => {
    addNewConnection();
    setActiveIntegration(name);
  };

  const onConnectAccountClick = () => {
    window.open(oauthUrl, '_self');
  };

  return (
    <div className="integrations__header-actions">
      <PrimaryToolTip
        align="center"
        position="bottom"
        anchorElement={
          !!accountsCount && (
            <div className="integrations__header-status">
              Accounts
              <AccountIcon className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">
                {accountsCount}
              </div>
            </div>
          )
        }
        useHover
      >
        Google Accounts used in сonnections
      </PrimaryToolTip>
      <PrimaryButton
        className="integrations__header-add-button-secondary"
        onClick={e => {
          e?.stopPropagation();
          onConnectAccountClick();
        }}
        color={ButtonColor.secondaryBlue}
      >
        Add an Account
      </PrimaryButton>
      {isAccountConnected && (
        <>
          <div className="integrations__header-status">
            Connections
            <LinkOutlined className="integrations__header-status-icon" />
            <div className="integrations__header-status-count">
              {spreadsheetCount}
            </div>
          </div>
          <PrimaryButton
            className="integrations__header-add-button-secondary"
            onClick={e => {
              e?.stopPropagation();
              onClickAddNew();
            }}
            color={ButtonColor.secondaryBlue}
            disabled={!accounts.find(acc => !acc.readOnly)}
          >
            Add a Connection
          </PrimaryButton>
        </>
      )}
    </div>
  );
};
